<template>
  <div
    class="raft-details-fieldgroup"
    :class="{ 'large-header': isBioStyling }"
  >
    <details :id="detailsId" :open="!isCollapsed">
      <summary>
        <span class="summary-title">
          {{ label }}
          <sup v-if="required" class="form-group required"> * </sup>
        </span>
      </summary>
      <p class="details-field-group-content">
        <slot name="content" />
        <slot />
      </p>
    </details>
  </div>
</template>

<script>
import chevronUp from "@/images/chevronUp.svg";
import chevronDown from "@/images/chevronDown.svg";

export default {
  name: "DetailsFieldGroup",
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    collapsed: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    isBioStyling: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isCollapsed: function () {
      return !!this.collapsed;
    },
    detailsId() {
      return this.isBioStyling ? "material-details" : this.id;
    },
  },
  data() {
    return {
      chevronDownSrc: `url(${chevronDown})`,
      chevronUpSrc: `url(${chevronUp})`,
      color: "blue",
    };
  },
};
</script>

<style scoped>
div.raft-details-fieldgroup {
  --accordion-title-bg-color: var(--gray-50, rgba(248, 248, 248, 1));
  width: 100%;
  border: none;
  text-align: left;
  font-weight: bold;
  font-size: 14px;
  background-color: var(--accordion-title-bg-color, #ffffff);
}

div.raft-details-fieldgroup details {
  margin: 0.5rem 0;
}

div.raft-details-fieldgroup details summary {
  list-style: none;
  background-color: var(--gray-100);
  margin: 0;
}

div.raft-details-fieldgroup details p {
  margin: 0;
  font-weight: normal;
}

div.raft-details-fieldgroup details summary > * {
  display: inline;
}

div.raft-details-fieldgroup details::before {
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  transition: opacity 0.2s;
}

div.raft-details-fieldgroup details[open]::before {
  opacity: 0.6;
}

div.raft-details-fieldgroup > details > summary {
  display: block;
  position: relative;
  font-weight: bold;
}

div.raft-details-fieldgroup > details > summary::before,
div.raft-details-fieldgroup > details > summary::after {
  width: 0.75em;
  height: 2px;
  position: absolute;
  top: 50%;
  right: 0.5rem;
  content: "";
  background-color: currentColor;
  text-align: right;
  transform: translateY(-50%);
  transition: transform 0.2s ease-in-out;
}

div.raft-details-fieldgroup > details > summary::after {
  transform: translateY(-50%) rotate(90deg);
}

div.raft-details-fieldgroup > details[open] > summary::after {
  transform: rotate(180deg);
}

#material-details > p > form > div > div.form-row {
  margin-top: 0.5rem;
}

div.large-header details summary span.summary-title {
  font-size: var(--font-size-200);
  line-height: calc(1.3 * var(--font-size-200));
  padding: 0.25rem;
}

:is(#raft-js, #raft-js-app) details {
  padding: 0;
}

.details-field-group-content {
  padding: 1rem;
  border: 1px solid var(--gray-200);

  /* Inner Shadow - Gray */
  box-shadow: inset 0px 2px 4px var(--gray-300);
  border-radius: 0 0 2px 2px;
}

:is(#raft-js, #raft-js-app) details summary {
  padding: 0.5rem;
}
</style>
